import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Sidebar } from './Sidebar'
import { Menu, LogOut } from 'lucide-react'
import { useState, useEffect } from 'react'

export const Layout = ({ children }) => {
  const { userProfile, stopImpersonating } = useAuth()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  
  // Impersonate durumunu kontrol et (hooks her zaman en üstte olmalı)
  const [isImpersonating, setIsImpersonating] = useState(false)

  useEffect(() => {
    const checkImpersonating = () => {
      const storedUser = localStorage.getItem('meb_auth_user')
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser)
          const impersonating = !!(userData.impersonated && userData.originalUser)
          setIsImpersonating(impersonating)
          console.log('Layout - Impersonate durumu:', impersonating, userData)
        } catch (e) {
          console.error('Impersonate kontrol hatası:', e)
          setIsImpersonating(false)
        }
      } else {
        setIsImpersonating(false)
      }
    }

    checkImpersonating()
    
    // Custom event listener (localStorage değişikliklerini yakalamak için)
    const handleStorageChange = () => {
      checkImpersonating()
    }
    
    window.addEventListener('localStorageChange', handleStorageChange)
    // Storage event (farklı tab'lar için)
    window.addEventListener('storage', handleStorageChange)
    
    // Interval kaldırıldı - sadece event listener kullanıyoruz (sürekli yenilemeyi önlemek için)
    
    return () => {
      window.removeEventListener('localStorageChange', handleStorageChange)
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  // Conditional return hooks'lardan sonra olmalı
  if (!userProfile) return null

  const handleStopImpersonating = async () => {
    try {
      console.log('Layout - Stop impersonating başlatılıyor...')
      await stopImpersonating()
      console.log('Layout - Stop impersonating başarılı, yönlendiriliyor...')
      // Sadece navigate, reload yok (state zaten güncellendi)
      navigate('/admin/users')
    } catch (error) {
      console.error('Layout - Stop impersonating hatası:', error)
      alert('Yönetici arayüzüne dönüş hatası: ' + (error.message || 'Bilinmeyen hata'))
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col lg:ml-64">
        {/* Top Header */}
        <header className="bg-white shadow-sm sticky top-0 z-30">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                <Menu size={24} />
              </button>
              <div className="flex-1 lg:ml-0">
                <h2 className="text-lg font-semibold text-gray-900">
                  MEB Bildirim Sistemi
                </h2>
              </div>
              
              {/* Impersonate durumunda yönetici arayüzüne dön butonu */}
              {isImpersonating && (
                <button
                  onClick={handleStopImpersonating}
                  className="flex items-center space-x-2 px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl transition-all duration-200 text-sm font-semibold"
                >
                  <LogOut size={18} />
                  <span className="hidden sm:inline">Yönetici Arayüzüne Dön</span>
                  <span className="sm:hidden">Yönetici</span>
                </button>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}



